import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Feedback from './Feedback';
import SettingsIcon from '@mui/icons-material/Settings';
import { useUser } from "../../../AuthContext";

const mainListItems = [
  { text: 'Generate', icon: <AutoAwesomeIcon />, to : '/dashboard/generate' },
];

const secondaryListItems = [
  { text: 'Settings', icon: <SettingsIcon />, to : '/dashboard/settings'},
  { text: 'Feedback', icon: <HelpRoundedIcon />, to : '/feedback'},
];

export default function MenuContent() {
  const location = useLocation();
  const [feedbackOpen, setFeedbackOpen] = React.useState(false);

  const handleClickOpen = () => {
    setFeedbackOpen(true);
  };

  const handleClose = () => {
    setFeedbackOpen(false);
  };

  return (
    <>
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton component={Link} to={item.to} selected={location.pathname === item.to}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            {item.text === 'Feedback' ? (
              <ListItemButton onClick={handleClickOpen}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ) : (
              <ListItemButton component={Link} to={item.to} selected={location.pathname === item.to}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            )}
          </ListItem>
        ))}
      </List>

    </Stack>
    <Feedback open={feedbackOpen} setOpen={setFeedbackOpen} />
    </>
  );
}

